/**
 * Number formatter function to convert units to milliseconds for Tanstack Query.
 *
 * @param {number} value - The value to be converted.
 * @param {string} unit - The unit of the value. Supported units: 's', 'min', 'hr', 'day'.
 * @returns {number} The converted value in milliseconds.
 * @throws {Error} - If the unit is unsupported.
 */
export function convertToMilliseconds(value, unit) {
  const unitConversions = {
    s: value * 1000, // seconds to milliseconds
    min: value * 60 * 1000, // minutes to milliseconds
    hr: value * 3600 * 1000, // hours to milliseconds
    day: value * 86400 * 1000, // days to milliseconds
  }

  if (!Object.hasOwnProperty.call(unitConversions, unit)) {
    throw new Error(`Unsupported unit: ${unit}`)
  }

  return unitConversions[unit]
}

/**
 * Helper function to easily manage staleTime and gcTime for Tanstack Query.
 *
 * @param {number} value - The value to be converted.
 * @param {string} [unit] - The unit of the value. Default is 'min'. Supported units: 's', 'min', 'hr', 'day'.
 * @throws {Error} - If the unit is unsupported.
 * @returns {number} The converted value in milliseconds.
 */
export function getQueryTime(value, unit = 'min') {
  return convertToMilliseconds(value, unit)
}
